import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import GeneralErrorSvg from "../../assets/svgicons/GeneralErrorIcon.svg?react";

const GeneralErrorIcon = (props) => {
  return (
    <SvgIcon component={GeneralErrorSvg} {...props} viewBox="0 0 366 244" />
  );
};

export default GeneralErrorIcon;
